import { ELEMENT_TYPE } from "./constants";
import PlayIcon from "@saas/components/assets/images/wang-editor/play.png";
import DeleteIcon from "@saas/components/assets/images/wang-editor/delete.png";
import LoadingImg from "@saas/components/assets/images/video-loading.gif";
import RefreshImg from "@saas/components/assets/images/wang-editor/refresh.png";
// 把自定义元素转成html元素
/**
 * @param elem 元素的数据结构，如上文的 Resume
 * @param childrenHtml 子节点的 HTML 代码
 * @returns 元素的 HTML 字符串
 */
const elemToHtml = (elem, childrenHtml) => {
  const {
    imgUrl = "",
    time = "",
    markType = "",
    lessonInfo,
    showTime,
    replay_url,
  } = elem;

  let replayUrl = "";
  if (replay_url) {
    replayUrl = replay_url;
  } else {
    replayUrl = `${process.env.VUE_APP_SAAS_WEB_URL}/video-play`;
    if (lessonInfo) {
      const { lesson_id, course_id, unit_id } = lessonInfo || {};
      replayUrl = `${replayUrl}/${course_id}/${unit_id}/${lesson_id}?time=${time}`;
    }
  }

  // 生成 HTML 代码，data-w-e-type用于标记元素类型，后面会用
  const html = `<div data-w-e-type="${ELEMENT_TYPE}" data-imgUrl="${imgUrl}" data-time="${time}" data-markType="${markType}" data-value="${childrenHtml}" data-showTime="${showTime}" data-replayUrl="${replayUrl}">
    <div style="width: 346px; display: block; background: transparent; position: relative; margin-top: 10px; margin-bottom: 10px;">
        <div style="width: 100%; height: 26px; margin-bottom: 8px;">
            <a href="${replayUrl}" target="_blank" style="float: left; width: 92px; height: 26px; display:inline-block; margin-right: 8px;">
                <div style="min-width: 92px; width: 92px; height: 26px; border-radius: 8px; border: 1.3px solid rgb(242, 243, 245); background: rgb(255, 255, 255); font-size: 14px; color: rgb(78, 89, 105); line-height: 26px; cursor: pointer;">
                    <img contenteditable="false" src="${PlayIcon}" style="vertical-align:text-bottom; width: 15px; min-height: 15px; min-width: 15px; height: 15px; margin-right: 5px; margin-left: 6px;">
                    ${showTime}
                </div>
            </a>
            <span style="float: left;height: 26px; line-height: 26px; display: inline-block; border-radius: 8px; border: 1.3px solid rgb(242, 243, 245); flex: 1 1 0%; padding: 0px 8px; color: rgb(255, 38, 92); overflow: hidden; font-size: 14px; background: rgb(255, 255, 255);">
                <span contenteditable="false" style="height: 26px; display: inline-block;">#</span>
                <span id="w-e-text-6" data-slate-node="text">
                    <span data-slate-leaf="true">
                        <span data-slate-string="true">${childrenHtml}</span>
                    </span>
                </span>
            </span>
        </div>
        <a href="${replayUrl}" target="_blank" style="width: 100%; height: 193px; margin-top: 8px; display:block;">
            <img src="${imgUrl}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px; border: 1px solid rgb(242, 243, 245);">
        </a>
    </div>
</div>`;
  return html;
};

// 编辑器输出html配置
export const elemToHtmlConfig = {
  type: ELEMENT_TYPE,
  elemToHtml: elemToHtml,
};
